import React, { useCallback } from "react"
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const ParticleBanner = () => {

  const particlesInit = useCallback(async engine => {
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
    await console.log(container);
  }, []);



  return (

    <Particles
      className="h-full bg-hero-bg-venture-studio bg-no-repeat bg-cover"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        // background: {
        //   color: {
        //     value: "#000"
        //   }
        // },
        fullScreen: false,
        fpsLimit: 30,

        "particles": {
          "number": {
            "value": 30,
            "density": {
              "enable": true,
              "value_area": 1000
            }
          },
          "color": {
            "value": ["#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d", "#3d3d3d",
              "#3d3d3d", "#3d3d3d", "#3d3d3d"]
          },
          "shape": {
            "type": "edge", //circle, edge, triangle, polygon, star, image 複数指定["circle", "triangle", "image"]

            "stroke": {
              "width": 0,
              "color": "#000000"
            },

            "polygon": {
              "nb_sides": 5
            },

            "image": {
              "src": "img/github.svg",
              "width": 100,
              "height": 100
            }
          },

          "opacity": {
            "value": 0.5,
            "random": true,

            "anim": {
              "enable": true, //true:有効, false:無効
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },

          "size": {
            "value": 50,
            "random": true, //true:有効, false:無効
            "anim": {
              "enable": false, //true:有効, false:無効
              "speed": 10,
              "size_min": 1,
              "sync": false //true:有効, false:無効
            }
          },

          "line_linked": {
            "enable": false, //true:有効, false:無効
            "distance": 150,
            "color": "#ffffff",
            "opacity": 0.4,
            "width": 1
          },

          "move": {
            "enable": true, //true:有効, false:無効
            "speed": 0.5,
            "direction": "top", //none, top, top-right, right, bottom-right, bottom, bottom-left, left, top-left
            "random": false, //true:有効, false:無効
            "straight": false, //true:有効, false:無効
            "out_mode": "out", //ボックス内で動かす bounce ボックス外に逃がす out
            "attract": {
              "enable": true,
              "rotateX": 1000,
              "rotateY": 1000
            }
          }
        },

        "interactivity": {
          "detect_on": "canvas",

          "events": {
            "onhover": {
              "enable": false, //true:有効, false:無効
              "mode": "bubble" //grad:付近のシェイプと線を繋ぐ, bubble:拡大, repulse:拒絶
            },

            "onclick": {
              "enable": true, //true:有効, false:無効
              "mode": "push" //push:追加, remove:削除, bubble:拡大, repulse:拒絶
            },
            "resize": true
          },

          "modes": {
            "grab": {
              "distance": 300,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 100,
              "size": 7.5,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 1
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        //Retina Display対応
        "retina_detect": true, //true:有効, false:無効

      }}
    />
  )
}

export default ParticleBanner
